import React from 'react';
import { Box, BoxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

// Distance the branch content is indented past the vertical spine (MUI spacing
// units → px). The per-item connector reaches back across exactly this gap.
const BRANCH_PADDING_PX = 24; // === pl: 3

/**
 * Horizontal connector line for a single tree row. Apply to the row element
 * (the card's <ListItem>) of every direct child inside a <TreeBranch>, so each
 * child visibly branches off the parent's spine — e.g. TICKET → each of its 8
 * service types, and each service type → each of its packages.
 */
export const treeItemSx: SystemStyleObject<Theme> = {
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: -BRANCH_PADDING_PX,
    top: '50%',
    width: BRANCH_PADDING_PX,
    height: '2px',
    backgroundColor: 'divider',
  },
};

/**
 * Wraps a nested level of the Service / Course settings hierarchy and draws a
 * vertical tree spine down its left edge. Combined with `treeItemSx` on each
 * child row, this renders a full tree (spine + a branch to every item). Used at
 * every nesting level in both settings tabs — replaces the plain
 * `<Box sx={{ pl: 4, pb: 2 }}>` wrapper.
 */
const TreeBranch: React.FC<BoxProps> = ({ children, sx, ...rest }) => (
  <Box
    sx={{
      position: 'relative',
      ml: 2,
      pl: `${BRANCH_PADDING_PX}px`,
      pb: 2,
      borderLeft: '2px solid',
      borderColor: 'divider',
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);

export default TreeBranch;
